import {
  Component,
  OnInit,
  Input,
  EventEmitter,
  Output,
  ElementRef,
  HostListener
} from "@angular/core";

// declare var $: any;

@Component({
  selector: "app-wn-dropdown",
  templateUrl: "./wn-dropdown.component.html",
  styleUrls: ["./wn-dropdown.component.css"],
  host: {
    "(document:click)": "onClickOutside()"
  }
})
export class WnDropdownComponent implements OnInit {
  constructor(private _eref: ElementRef) {}

  private previousIndex: number = null;
  public searchKeyword: string = null;
  public dropdownToggle = true;
  public search = false;
  public selectedId: any;
  public items: any = [];
  public itemsBackup: any = [];
  public configuration: any = [];
  public defaultSetting: any = {
    image: true,
    idField: null,
    imageField: null,
    textField: null,
    subField: null
  };

  @Input() inputModel: any = [];
  @Output() inputModelChange = new EventEmitter<string>();

  @Input()
  set data(data: []) {
    if (Array.isArray(data) && data.length > 0) {
      this.items = data;
      this.itemsBackup = data;
      if (localStorage.getItem("projectId") == null) {
        this.clickItem(this.items[0]);
      } else {
        let currentId = JSON.parse(localStorage.getItem("projectId"));
        var findItem = this.items.find((x) => x.id == currentId);
        if (findItem != null) {
          this.clickItem(findItem);
        } else {
          this.clickItem(this.items[0]);
        }
      }
    }
  }

  @Input() set pushData(pushData) {
    // this.items = pushData;
    console.log("Pushdata", pushData);
    ////////////////
    if (pushData != null) {
      var findItem = this.items.findIndex((x) => x.id == pushData.id);
      if (findItem == -1) {
        this.items.push(pushData);
      } else {
        this.items.splice(findItem, 1);
      }
    }

    // this.itemsBackup = pushData;
    console.log("Items", this.items);
  }

  @Input()
  set setting(setting: any) {
    // RESETTING CONFIGURATION FOR NEW SETTINGS
    this.configuration = {};

    // SETTING NEW CONFIGURATION
    if (setting != "") {
      for (let [key, value] of Object.entries(this.defaultSetting)) {
        if (setting.hasOwnProperty(key)) {
          this.configuration[key] = setting[key];
        } else {
          this.configuration[key] = value;
        }
      }
    }
  }

  // @Input() set selected(selected: any) {
  //   this.selectedId = selected;
  //   console.log("Selected Id", this.selectedId);
  // }

  @Output() onSelect: EventEmitter<any> = new EventEmitter();

  ngOnInit() {
    console.log(this.configuration);
    console.log(this.items);
    ////////////////
  }

  wn_title: any = "Select Project";
  onClickOutside() {
    // console.log('document:click');
    if (!this._eref.nativeElement.contains(event.target)) {
      // or some similar check
      this.dropdownToggle = true;
    }
  }

  // @HostListener('document:click', ['$event'])
  // @HostListener('document:touchstart', ['$event'])
  // handleOutsideClick(event) {
  //   if (!this._eref.nativeElement.contains(event.target)) {
  //     this.dropdownToggle = true;
  //   }
  //   console.log('Host Listner');
  // }

  clickItem(item) {
    // console.log($(".wn-select"));
    this.onSelect.emit(item);
    let index = this.itemsBackup.findIndex((e) => e == item);

    // if(this.search == true){
    //   this.items[index]['selected'] = true;
    // }else{

    // }
    // this.itemsBackup[index]['selected'] = true;

    // FOR UNSELECT ON CLICK
    // if(this.items[index]['selected'] == true){
    //   this.items[index]['selected'] = false;
    // }else{
    //   this.items[index]['selected'] = true;
    //   if(this.previousIndex != null && this.previousIndex != index){
    //     this.items[this.previousIndex]['selected'] = false;
    //   }

    // }

    this.items[index]["selected"] = true;

    this.inputModel = [];
    this.inputModel.push(this.items[index]);
    this.inputModel.length;
    //this.wn_title = this.inputModel[0]['name'];
    if (this.previousIndex != null && this.previousIndex != index) {
      this.items[this.previousIndex]["selected"] = false;
    }

    this.previousIndex = index;
    this.dropdownToggle = true;
    // console.log(this.inputModel);
  }

  onSearch() {
    if (this.searchKeyword == "") {
      this.search = true;
    } else {
      this.search = false;
    }
  }
}
